module.exports = __webpack_public_path__ + "static/media/one.162a5a23.svg";